import type { Catalog } from '..'

export const ui: Catalog['ui'] = {
  confirm: 'Confirmar',
  copyCode: 'copiar',
  showSidebar: 'Mostrar barra lateral',
  doopHome: 'Início do Doop',
  setUpManually: 'Configurar manualmente',
  selectedOf: '{count} de {total} selecionados',
}
